/** 数据集 */
export const keysConstant = {
  /** 专业技术职务 */
  T_DIC_PROTECH: 'T_DIC_ProTech',
  /** 职业(工种)资格、意向岗位 */
  T_DIC_PROQUALITY: 'T_DIC_ProQuality',
  /** 所属地区行政区划代码 */
  T_DIC_AREACODE: '8dae73ae643e43a49dea6e3e607d0878',
  /** T_DIC_Nation：民族 */
  T_DIC_NATION: 'T_DIC_Nation',
  /** T_DIC_Politics：政治面貌 */
  T_DIC_POLITICS: 'T_DIC_Politics',
  /** T_DIC_Education：学历 */
  T_DIC_EDUCATION: 'T_DIC_Education',
  /** T_DIC_AAC033：健康状况 */
  T_DIC_AAC033: 'T_DIC_AAC033',
  /** T_PSM_Domicile：户口性质 */
  T_PSM_DOMICILE: 'T_PSM_Domicile',
  /** T_DIC_UnempReason：失业原因 */
  T_DIC_UNEMPREASON: 'T_DIC_UnempReason',
  /** T_DIC_FWorkType：原工种 */
  T_DIC_FWORKTYPE: 'T_DIC_FWorkType',
  /** T_DIC_ProLevel：职业资格等级 */
  T_DIC_PROLEVEL: 'T_DIC_ProLevel',
  /** T_DIC_WorkEnvironment：工作环境 */
  T_DIC_WORKENVIRONMENT: 'T_DIC_WorkEnvironment',
  /** T_DIC_WorkNature：工作性质 */
  T_DIC_WORKNATURE: 'T_DIC_WorkNature',
  /** T_DIC_Profession：所学专业 */
  T_DIC_PROFESSION: 'T_DIC_Profession',
  /** T_DIC_Language：外语语种 */
  T_DIC_LANGUAGE: 'T_DIC_Language',
  /** T_DIC_Languageskill：外语水平 */
  T_DIC_LANGUAGESKILL: 'T_DIC_Languageskill',
  /** T_DIC_ComputerSkill：计算机水平 */
  T_DIC_COMPUTERSKILL: 'T_DIC_ComputerSkill',
  /** T_DIC_WageLevel：试用期月工资档次 */
  T_DIC_WAGELEVEL: 'T_DIC_WageLevel',
  /** T_PSM_EmployType：就业类型 */
  T_PSM_EMPLOYTYPE: 'T_PSM_EmployType',
  /** T_DIC_FlexiType：灵活就业方式 */
  T_DIC_FLEXITYPE: 'T_DIC_FlexiType',
  /** T_DIC_LicenseType：驾照类型 */
  T_DIC_LICENSETYPE: 'T_DIC_LicenseType',
  /** T_DIC_EmpHard：人员类别 */
  T_DIC_EMPHARD: 'T_DIC_EmpHard',
  /** T_DIC_Industry：所属行业 */
  T_DIC_INDUSTRY: 'T_DIC_Industry',
  /** T_DIC_UnitType：单位类型 */
  T_DIC_UNITTYPE: 'T_DIC_UnitType',
  /** T_DIC_Economic：经济类型 */
  T_DIC_ECONOMIC: 'T_DIC_Economic',
  /** T_DIC_Person：人员规模 */
  T_DIC_PERSON: 'T_DIC_Person',
  /** T_DIC_ProTecnLevel：专业技术等级 */
  T_DIC_PROTECNLEVEL: 'T_DIC_ProTecnLevel',
  /** T_PSM_SalaryPackage：期望薪资 */
  T_PSM_SALARYPACKAGE: 'T_PSM_SalaryPackage',
  // /** T_DIC_Academic： '学历 */
  // T_DIC_ACADEMIC: 'T_DIC_Academic',
  /** '-1'：地区 */
  NATION: '-1',
  /** 20：福建 */
  FUJIAN: '20',
}